/**
 * User roles available in the system.
 * These map to the `role.name` field in the API response.
 */
export enum UserRoleEnum {
  Agent = 'agent',
  AgencyManager = 'agency manager',
  Developer = 'developer',
  DeveloperViewer = 'developer viewer',
  MasterAgent = 'master agent',
}

/**
 * Permission identifiers used with ngx-permissions.
 * Extend this enum as new permissions are added.
 */
export enum Permission {
  ViewProjects = 'view-projects',
  ManageProjects = 'manage-projects',
  ViewReservations = 'view-reservations',
  ManageReservations = 'manage-reservations',
  ViewAgencies = 'view-agencies',
  ManageAgencies = 'manage-agencies',
  ViewUsers = 'view-users',
  ManageUsers = 'manage-users',
}
